import { useCallback, useEffect, useRef, useState } from "react";
import ExceptionErrorLogs from "./ExceptionErrorLogs";
import { useDispatch, useSelector } from "react-redux";
import { Datepicker, EventHandler, InputField } from "client/CommonComponents";
import ErrorLogDisptch from "Store/Identity/ErrorLog/ErrorLogDispatch";
import ComponentErrorLogDisptch from "../Store/Identity/ComponentErrorLog/ComponentErrorLogDispatch"
import { Application } from "utils";


const ExceptionErrorLogsContainer = () => {
  const dispatch = useDispatch();
  const dispatchErrorLogs = ErrorLogDisptch.dispatchGetErrorLogs(dispatch)
  const dispatchSetErrorLogParameter = ComponentErrorLogDisptch.dispatchSetErrorLogParameter(dispatch)

  const { errorLogsData} = useSelector((state: any) => ({
    errorLogsData: state.ErrorLogReducer.errorLogs
  }));

  const [showErrorPopup, setShowErrorPopup] = useState<boolean>(false);
  const [exceptionErrorLogDetails, setExceptionErrorLogDetails] = useState<any>([])
  const errorLogParam: any = {
    initialRowId: 0,
    pageSize: 10,
    errorType: null,
    errorDescription: null,
    errorMessage: null,
    applicationType: null,
    isReact: null,
    created: null,
    sortColumn: null,
    sortOrder: null
  }  
  const [errorType, setErrorType] = useState<any>()
  const [errorDescription, setErrorDescription] = useState<any>()
  const [errorMessage, setErrorMessage] = useState<any>()
  const [applicationType, setApplicationType] = useState<any>()
  const [isReact, setIsReact] = useState<any>()
  const [created, setCreated] = useState<any>()

  const [paginationData, setPaginationData] = useState<any>({})
  const [pagesCount, setPagesCount] = useState<number>(0)  
  const createdDate = useRef<any>(null);
  const [sortData, setSortData] = useState<any>({})

  const handleFilterClear = () => {
    dispatchSetErrorLogParameter({})
    setErrorDescription('')
    setErrorMessage('')
    setApplicationType('')
    setIsReact(null)
    setErrorType('')
    setCreated(null)
    createdDate.current = null
    setSortData({})
  }
  
  useEffect(() => {
    if (paginationData.pageSize) {

      let tempInitialRowId = (paginationData.pageIndex === 0 || paginationData.pageIndex === undefined) ? 0 : paginationData.pageSize * paginationData.pageIndex
      errorLogParam.initialRowId = tempInitialRowId
      errorLogParam.pageSize = paginationData.pageSize
      errorLogParam.errorType = errorType
      errorLogParam.errorMessage = errorMessage
      errorLogParam.errorDescription = errorDescription
      errorLogParam.applicationType = applicationType
      errorLogParam.isReact = isReact
      errorLogParam.created = created
      errorLogParam.sortColumn = sortData.key
      errorLogParam.sortOrder = sortData.sortDirection !== null && sortData.sortDirection !== undefined ? sortData.sortDirection.toUpperCase() : sortData.sortDirection

      dispatchErrorLogs(errorLogParam)
      dispatchSetErrorLogParameter(errorLogParam)
    }
  }, [paginationData, errorType, errorMessage, errorDescription, applicationType, isReact, created, sortData])


  useEffect(() => {
    if (errorLogsData.totalRecordCount && paginationData.pageSize) {

      let pageSize = paginationData.pageSize ?? errorLogParam.pageSize
      let tempPageCount = errorLogsData.totalRecordCount > pageSize ? Math.ceil(errorLogsData.totalRecordCount / pageSize - 1) : 0
      setPagesCount(tempPageCount)

    }
  }, [errorLogsData.totalRecordCount, paginationData.pageSize])

  const fetchAction = useCallback((fetchData:any) => {
    
    if(fetchData.action && fetchData.action === "paging"){   
      let paginationData = fetchData.data
      setPaginationData(paginationData)
    } 
    if(fetchData.action && fetchData.action === "sorting"){
      setSortData(fetchData.data[0])
    }  
   }, [])

  const getRowDetails = (e: any, row: any) => {

    e.preventDefault();
    setShowErrorPopup(true)
    if (row.rowData) {
      setExceptionErrorLogDetails(row.rowData)
    }
  }

  const hideShowErrorPopup = () => {
    setShowErrorPopup(false)
    setExceptionErrorLogDetails([])
  }

  const TextFilterCell = (props: any) => {
    const { column } = props;
    const { errorLogValue } = useSelector((state: any) => ({
      errorLogValue: state.ComponentErrorLogReducer.errorLogParam
    }));
    const textFilterHandleChange = (event: any) => {

      let filterValue = event?.target?.value
      let filterColumnName = event?.target?.name

      if (filterColumnName === "errorType") {
        setErrorType(filterValue)
      }
      else if (filterColumnName === "errorMessage") {
        setErrorMessage(filterValue)
      }
      else if (filterColumnName === "errorDescription") {
        setErrorDescription(filterValue)
      }
      else if (filterColumnName === "applicationType") {
        setApplicationType(filterValue)
      }

    }

    const getFilterValue = () => {
      if (column?.key === "errorType") {
        return errorLogValue?.errorType
      }
      else if (column?.key === "errorMessage") {
        return errorLogValue?.errorMessage
      }
      else if (column?.key === "errorDescription") {
        return errorLogValue?.errorDescription
      }
      else if (column?.key === "applicationType") {
        return errorLogValue?.applicationType
      }
    }

    return (
      <div>
        <InputField
          name={column.key}
          onChange={(e: any) => { textFilterHandleChange(e) }}
          value={getFilterValue()}
         data-attribute="ExceptionErrorLogs_container_key_Input" />
      </div>
    )

  }

  const ApplicationDropdownFilter = (props: any) => {
    const { column } = props;
    const { errorLogValue } = useSelector((state: any) => ({
      errorLogValue: state.ComponentErrorLogReducer.errorLogParam
    }));    
    const [dropdownValue, setDropdownValue] = useState("Select")

    const options = [Application.REACT, Application.API]
    
    const applicationHandleChange = (event: any) => {
      if (event?.target?.value !== "Select") {
        if (event?.target?.value === Application.REACT) {
          setDropdownValue(Application.REACT)
          setIsReact(true)          
        }
        else if (event?.target?.value === Application.API) {
          setDropdownValue(Application.API)
          setIsReact(false)          
        }
      }
    };


    return (
      <div>
        <select
          name={column?.key}
          onChange={(e: any) => { applicationHandleChange(e) }}
          className="form-control"
          value={(errorLogValue?.isReact === null || errorLogValue?.isReact === undefined) ? "Select" : dropdownValue}
         data-attribute="ExceptionErrorLogs_container_Default_Select">
          <option>Select</option>
          {options?.map((item: any, index: number) => {
            return (
              <option key={index}>{item}</option>
            )
          })}
        </select>
      </div>
    );
  };

  const handlecreatedDateFilter = (date: any) => {

    createdDate.current = date;
    let dateValue = new Date(date)
    const createdDateValue = dateValue.toLocaleDateString('en-CA')
    setCreated(createdDateValue)  

  }

  const CreatedDateFilterCell = () => {

    return (
      <div className="date-filter-wrapper">
        <Datepicker
          placeholder="Select"
          value={createdDate.current}
          onChangeDate={(date: any) =>
            handlecreatedDateFilter(date)
          }
          allowTextInput={false}
         data-attribute="ExceptionErrorLogs_container_Default_Datepicker" />
      </div>
    );
  };

  const errorLogsColumn = [
    {
      key: "action",
      title: "Action",
      width: 60,
      Cell: (row: any) => {
        return (         
                                <EventHandler onEvent={(e: any) => { getRowDetails(e, row) }} data-attribute="ExceptionErrorLogs_container_Default_EventHandler">
                                  <div className="action-menu">
                                    <span className="fa fa-ellipsis-h"></span>
                                  </div>
                                </EventHandler>           
               );
      },
      FilterCell: null      
    },
    {
      key: "errorType",
      title: "Error Type",
      width: 150,      
      FilterCell: (Props: any) => {
        return <TextFilterCell {...Props} />
      }
    },
    {
      key: "errorMessage",
      title: "Error Message",
      FilterCell: (Props: any) => {
        return <TextFilterCell {...Props} />
      }
    },
    {
      key: "errorDescription",
      title: "Error Description",
      Cell: (row: any) => {
        let rowValue = row.rowData.errorDescription
        return (rowValue.length >= 150 ? `${rowValue.substring(0, 150)}...` : rowValue);
      },
      FilterCell: (Props: any) => {
        return <TextFilterCell {...Props} />
      }
    },
    {
      key: "applicationType",
      title: "Application Type",
      width: 180,
      FilterCell: (Props: any) => {
        return <TextFilterCell {...Props} />
      }
    },
    {
      key: "isReact",
      title: "Application",
      width: 150,
      Cell: (row: any) => {
        return (row.rowData.isReact ? Application.REACT : Application.API);
      },
      FilterCell: (Props: any) => {
        return <ApplicationDropdownFilter {...Props} />;
      }
    },
    {
      key: "created",
      title: "Date",
      width: 180,
      Cell: (row: any) => {
        let dateValue = new Date(row.rowData.created)
        return dateValue.toLocaleString();
      },
      FilterCell: (Props: any) => {
        return <CreatedDateFilterCell />
      }
    }
  ];
  
  return (
    <ExceptionErrorLogs
      errorLogsData={errorLogsData.exceptionErrorLogsList}
      errorLogsColumn={errorLogsColumn}
      showErrorPopup={showErrorPopup}
      hideShowErrorPopup={hideShowErrorPopup}
      exceptionErrorLogDetails={exceptionErrorLogDetails}
      pagesCount={pagesCount}
      totalItem={errorLogsData.totalRecordCount}
      handleFilterClear={handleFilterClear}
      fetchAction={fetchAction}
    />
  )
}

export default ExceptionErrorLogsContainer;